export const EXAMPLE_THREAD_ROUTE_PREFIX = 'ot_example' as const;
export const EXAMPLE_HELP_ACCESS_DURATION_MS = 24 * 60 * 60 * 1000;
export const EXAMPLE_WORKSPACE_THREAD_SEED_IDS = [
  'how-imai-can-help',
  'ideate-sneakers',
  'ideate-dresses',
  'ideate-jewelry',
] as const;

export type ExampleWorkspaceThreadSeedId =
  (typeof EXAMPLE_WORKSPACE_THREAD_SEED_IDS)[number];

export function exampleWorkspaceThreadRouteIdForSeed(args: {
  organizationId: string;
  seedId: ExampleWorkspaceThreadSeedId;
}): string {
  const workspaceId = args.organizationId.trim();
  if (!workspaceId) throw new Error('Example workspace route requires an org');
  return `${EXAMPLE_THREAD_ROUTE_PREFIX}-${args.seedId}-${workspaceId}`;
}

export function exampleWorkspaceHelpThreadRouteId(
  organizationId: string
): string {
  return exampleWorkspaceThreadRouteIdForSeed({
    organizationId,
    seedId: 'how-imai-can-help',
  });
}

export function isReservedExampleWorkspaceThreadRoute(args: {
  organizationId: string;
  routeId: string | null | undefined;
}): boolean {
  return EXAMPLE_WORKSPACE_THREAD_SEED_IDS.some(
    (seedId) =>
      args.routeId ===
      exampleWorkspaceThreadRouteIdForSeed({
        organizationId: args.organizationId,
        seedId,
      })
  );
}

export function isProtectedExampleWorkspaceHelpThread(args: {
  organizationId: string;
  routeId: string | null | undefined;
  exampleThreadSeedId: string | null | undefined;
}): boolean {
  return (
    args.exampleThreadSeedId === 'how-imai-can-help' &&
    args.routeId === exampleWorkspaceHelpThreadRouteId(args.organizationId)
  );
}

export function canDeleteExampleWorkspaceThread(args: {
  organizationId: string;
  routeId: string | null | undefined;
  exampleThreadSeedId: string | null | undefined;
}): boolean {
  return !isProtectedExampleWorkspaceHelpThread(args);
}

export function canRenameExampleWorkspaceThread(args: {
  organizationId: string;
  routeId: string | null | undefined;
  exampleThreadSeedId: string | null | undefined;
}): boolean {
  if (!args.exampleThreadSeedId) return true;
  if (
    !EXAMPLE_WORKSPACE_THREAD_SEED_IDS.some(
      (seedId) => seedId === args.exampleThreadSeedId
    )
  ) {
    return true;
  }
  return !isReservedExampleWorkspaceThreadRoute(args);
}

export function isExampleHelpAccessActive(
  workspaceCreatedAt: number,
  now = Date.now()
): boolean {
  const age = now - workspaceCreatedAt;
  return age >= 0 && age < EXAMPLE_HELP_ACCESS_DURATION_MS;
}
